import React from 'react'
let PropTypes = React.PropTypes

import classNames from 'classnames/bind'
import * as css from './Modales.css'
let cx = classNames.bind(css)

export class ReemplazoIMG extends React.Component{
    constructor(props){
        super(props)
        this.state = {
            index: 0,
            IMG: '',
            reemplazo: [],
            cantReemplazos: 0
        }
        this.previa = ()=>{
            this.setState({
                index: this.state.index>0? this.state.index-1 : this.state.index
            },()=>this.setImagen())
        }
        this.siguiente = ()=>{
            this.setState({
                index: this.state.index<(this.state.cantReemplazos-1)? this.state.index+1 : this.state.index
            },()=>this.setImagen())
        }
        this.setImagen = ()=>{
            this.setState({
                reemplazo: this.props.reemplazos[this.state.index]
            })
        }
        this.seleccionarImagen = ()=>{
            this.props.reemplazarImagen(this.state.reemplazo.idArchivoImagen)
            this.props.hideReemplazo()
        }
    }
    componentWillMount(){
        this.setImagen()
        this.setState({
            cantReemplazos: Object.keys(this.props.reemplazos).length
        })
    }
    render() {
      return (
            <div className="col-md-10">
                <div className="panel panel-info">
                    <div className="panel-heading">
                        <h5 className={cx("panel-title", 'panelTitleCustom')}>
                                <label className="col-md-8">Posibles Reemplazos</label>
                                <button className={cx("btn btn-xs", 'btnSeleccionar')} onClick={this.seleccionarImagen} disabled={this.props.reemplazos.length===0? true : false}><span className="glyphicon glyphicon-ok" aria-hidden="true"></span> Seleccionar</button>
                        </h5>
                    </div>
                    <div className="panel-body">
                        <div className={cx("col-md-12", 'divCenter')}>
                            {
                                this.props.reemplazos.length===0?
                                    <div colSpan="21" style={{textAlign: 'center'}}><b>No se encontraron coincidencias</b></div>
                                :   
                                    <div className="col-md-12">
                                        <img src={`${this.state.reemplazo.ruta_imagen}`} className={cx('imagenPosible')}/>
                                        {
                                            this.state.reemplazo.original?
                                                <label className={cx('labelOriginal')}>Imagen Original</label>
                                            :
                                                null
                                        }
                                    </div>
                            }
                        </div>
                        <div className="col-md-12">
                            <nav aria-label="...">
                                <ul className="pager">
                                    <li><a className={cx('btnPrevio')} onClick={this.previa} disabled={this.props.reemplazos.length===0? true : false}><span className="glyphicon glyphicon-arrow-left" aria-hidden="true"/></a></li>
                                    <li><a className={cx('btnSiguiente')} onClick={this.siguiente} disabled={this.props.reemplazos.length===0? true : false}><span className="glyphicon glyphicon-arrow-right" aria-hidden="true"></span></a></li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./frontEnd/auditorias/revision/ReemplazoIMG.jsx